import React from 'react'
import IconEdit from '../components/icon/IconEdit';
import IconTrash from '../components/icon/IconTrash';
import cn from 'classnames';
import {createUseStyles} from 'react-jss';

export interface MenuItem {
  title: string
  onClick: (e: React.MouseEvent) => void
  iconId: string
}

type ActionToolbar = {
  items: MenuItem[]
}

export default function ActionToolbar({items}: ActionToolbar) {

  const styles = createUseStyles({
    hover: {
      '&:hover': {
        backgroundColor: '#367CCE !important'
      }
    }
  })();

  const icon = (iconId: string, className: string) => {
    switch (iconId) {
      case 'edit':
        return <IconEdit className={className}/>;
      case 'delete':
        return <IconTrash className={className}/>;
    }
    return <span/>;
  }

  return (
    <div className="flex group">
      {items.map((item, index) => (
        <button onClick={item.onClick} key={index}
          className={cn('group-hover:bg-blue group-hover:text-white px-2 py-1', {
            'rounded-l-md': index === 0,
            'rounded-r-md': index === items.length - 1,
            'border-r border-white group-hover:border-blue-table-active  group-hover:border-opacity-80': index !== items.length - 1
          }, styles.hover)}
        >
          {icon(item.iconId, 'w-4 h-4  group-hover:text-white')}
        </button>
      ))}
    </div>
  )
}
